/**
 * Configuration for page builder tools and features.
 */

/**
 * Controls whether the Resene color picker tool is enabled.
 * Set to true to enable the Resene tool, false to disable it.
 */
export const RESENE_TOOL_ENABLED = false;
